<template>
    <div>
        <Form
                v-bind:controls="controls"
                v-bind:title="title"
                v-bind:intro="intro"
                v-bind:action="action"
                v-bind:formid="formid"
                v-bind:csrf="csrf"
                v-bind:error="error"
                v-on:submitSuccess="doRedirect"

                v-if="controls"
        >
            <template v-slot:buttons>
                <div class="d-flex">
                    <back-button v-if="!['documents'].includes($route.name)"></back-button>
                    <button class="button form__button ml-auto" type="submit">
                        <T>Bevestigen</T> <i class="icon-chevron-right button__icon button__icon--right"></i>
                    </button>
                </div>
            </template>
        </Form>
    </div>
</template>

<script>
    import {mapState} from 'vuex';

    export default {
        name: 'DocumentNotAvailable',
        data: function(){
            return {
                controls: null,
                title: null,
                documentTitle: null,
                action: null,
                intro: null,
                formid: null,
                csrf: null,
                error: null
            };
        },
        computed: mapState(['activeLocale']),
        watch: {
            // when the activeLocale change then try to translate again
            activeLocale() {
                this.getForm();
            },
        },
        methods: {
            doRedirect(data) {
                if(! data.documentsRemaining) {
                    this.$router.push({ name:'thank-you'});
                }else {
                    this.$router.push({ name:'documents'});
                }
            },
            getForm() {
                let self = this;

                self.$store.commit('setLoading',true);

                // get the current document
                this.$Api.get('document-ignore/' + this.$route.params.document)
                    .then(function(response) {
                    self.formid = response.data.formid;
                    self.controls = response.data.controls;
                    self.action = response.data.action;
                    self.documentTitle = response.data.title;
                    self.title = t('Waarom is het document @title niet beschikbaar', {'@title': response.data.title});
                    self.csrf = response.data.csrf;
                    self.error = response.data.error;
                });
            }
        },
        created: function() {
            this.getForm();
        },


    }
</script>



// WEBPACK FOOTER //
// src/views/DocumentNotAvailable.vue